var _a;
export class Deferred {
    constructor() {
        this._resolveSelf = () => null;
        this._rejectSelf = () => null;
        this[_a] = 'ASymbol_Deferred_pillow_talk';
        this.promise = new Promise((resolve, reject) => {
            this._resolveSelf = resolve;
            this._rejectSelf = reject;
        });
    }
    then(onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.promise.catch(onrejected);
    }
    finally(onfinally) {
        return this.promise.finally(onfinally);
    }
    resolve(val) {
        this._resolveSelf(val);
    }
    reject(reason) {
        this._rejectSelf(reason);
    }
}
_a = Symbol.toStringTag;
